const vapeuksupplier = {
    id: 'vapeuksupplier',
    publicSiteName: 'Vape UK Supplier',
    branch: process.env.NEXT_PUBLIC_SHOP_BRANCH,
    siteUrl: process.env.NEXT_PUBLIC_SITE_URL,
    googleVerification: process.env.NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION,
    gaId: process.env.NEXT_PUBLIC_GA_ID,
    theme: {
        colors: {
            primary: '#e1262d',
            secondary: '#222663',
            color1: '#b80a11',
        },
        fonts: {
            body: 'var(--font-sans)',
            heading: 'var(--font-heading)',
        },
        radius: '4px',
        header: {
            layout: 'classic',
            dark: false,
            sticky: true,
            showSearch: true,
            showAccount: true,
            showWishlist: true,
            showAnnouncementBar: true,
            transparent: false,
        }
    },
    assets: {
        favicon: '/vapeuksupplier/favicon.ico',
        logo: '/vapeuksupplier/logo.png',
    },
    features: {
        rewards: true,
        subscriptions: true,
    },
}

export default vapeuksupplier